import React, { useState } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import MainPage from './pages/main-page';
import { theme } from './styles/Theme';
import ResultsPage from './pages/results-page';
import ResultsContext from './pages/ResultsContext';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import { AuthProvider } from './pages/AuthContext';

function App() {
  const [folderId, setFolderId] = useState(null);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' elemment={<Root />}>
        <Route
          path='/results'
          element={
            <ResultsPage />
          }
        />
        <Route
          index
          element={
            <MainPage />
          }
        />
      </Route>
    )
  );

  return (
    <AuthProvider>
      <ResultsContext.Provider value={{ folderId, setFolderId }}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </ResultsContext.Provider>
    </AuthProvider>
  );
}

const Root = () => {
  return <></>;
};

export default App;
